import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchPlatformMetricsSummary } from '@/api/platformMetrics/platformMetricsApi';
import type { PlatformMetricsSummary } from '@/api/platformMetrics/platformMetricsApi.types';
import { PLATFORM_METRICS_SUMMARY_QUERY_KEY } from '@/constants/queryKeys';

export function usePlatformMetricsSummaryQuery(
  isEnabled: boolean
): UseQueryResult<PlatformMetricsSummary, Error> {
  return useQuery({
    queryKey: PLATFORM_METRICS_SUMMARY_QUERY_KEY,
    queryFn: fetchPlatformMetricsSummary,
    enabled: isEnabled,
  });
}
